module.exports ={
    help_center: '帮助中心',
    go_to: '回到UPlus',
}
